import React from 'react';
import Link from 'next/link';

interface ConsentTextProps {
  className?: string;
}

export default function ConsentText({ className = '' }: ConsentTextProps) {
  return (
    <p className={`text-xs leading-relaxed text-current opacity-80 ${className}`}>
      By continuing you agree to our{' '}
      <Link href="/terms-and-conditions" target="_blank" className="font-semibold underline underline-offset-2">
        Terms and Conditions
      </Link>{' '}
      and confirm you&apos;ve read our{' '}
      <Link href="/privacy-policy" target="_blank" className="font-semibold underline underline-offset-2">
        Privacy Notice
      </Link>
      .
    </p>
  );
}
